import { render, staticRenderFns } from "./Competencia.vue?vue&type=template&id=00dc8c0b&scoped=true"
import script from "./Competencia.vue?vue&type=script&lang=js"
export * from "./Competencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc8c0b",
  null
  
)

export default component.exports